import { errorLogger } from '@utils/applicationLogUtils';
import React, { useEffect, useRef, useState } from 'react';
import "./poshan.css";
import PoshanServiceListCard from './PoshanServiceListCard';
import PoshanServiceDetails from './PoshanServiceDetails';
import { postDataJSON } from '@services/CommonApiService';
import endpoints from '@config/endpoints';
import Button from '@components/common/Button';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import BackArrowsvg from '@assets/svg_main/BackArrowIconSvg.svg'
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Spinner from '@components/common/Spinner';
import ServiceListSkeleton from './ServiceListSkeleton';

dayjs.extend(customParseFormat);


// const COUNTDOWN_START = 30;

const PoshanComponent = () => {
    const [poshanServiceHeader, setPoshanServiceHeader] = useState<string>('Poshan Service');
    const [lastFetchedDate, setLastFetchedDate] = useState<string>('');
    const [serviceListFromDB, setServiceListFromDB] = useState<any>([]);
    const [poshanServiceDetails, setPoshanServiceDetails] = useState<any>(null);
    const [isCardClicked, setIsCardClicked] = useState<boolean>(false);
    const [isNutriInfoAvailable, setIsNutriInfoAvailable] = useState<boolean>(false);
    const [isLoadingList, setIsLoadingList] = useState<boolean>(false);
    const [isLoadingDetails, setIsLoadingDetails] = useState<boolean>(false);
    const [isLoadingPoshanData, setIsLoadingPoshanData] = useState<boolean>(false);
    const [loadingMessage, setLoadingMessage] = useState<string>('Fetching Nutritional data from Poshan...');
    // const [countdown, setCountdown] = useState<number>(COUNTDOWN_START);
    // const [showRetryButtons, setShowRetryButtons] = useState<boolean>(false);
    // const [showCancelButtons, setShowCancelButtons] = useState<boolean>(false);
    const abortControllerRef = useRef<AbortController | null>(null);
    const isChild = useSelector((state: RootState) => state.beneficiary.isChild);
    const benfDetails = useSelector((state: RootState) => state.beneficiary.beneficiaryDetails);

    useEffect(() => {
        initialFetch(true);
    }, []);

    // useEffect(() => {
    //         if (isLoadingPoshanData) {
    //             const interval = setInterval(() => {
    //                 setCountdown((prevCountdown) => {
    //                     if (prevCountdown > 1) {
    //                         // if (prevCountdown === 20) setLoadingMessage('Almost there...');
    //                         return prevCountdown - 1;
    //                     } else {
    //                         clearInterval(interval);
    //                         cancelFetch();
    //                         setShowRetryButtons(true);
    //                         setShowCancelButtons(false);
    //                         return 0;
    //                     }
    //                 });
    //             }, 1000);
    //             return () => clearInterval(interval);
    //         }
    //     }, [isLoadingPoshanData]);

    const initialFetch = async (showLoader:boolean) => {
        try {
            showLoader && setIsLoadingList(true);
            const payload = {
                beneficiaryId: benfDetails?.[0]?.benef_id
            }
            const response = await postDataJSON<any>(`${endpoints.fetchServiceListFromRCH}`, payload);

            if(response?.data?.length > 0){
                setIsNutriInfoAvailable(true);
                const copiedData = response.data.slice();
                const sortedData = copiedData.sort((a: any, b: any) => {
                    const dateA = dayjs(a.last_call_date, "DD-MM-YYYY hh:mm A").isValid()
                        ? dayjs(a.last_call_date, "DD-MM-YYYY hh:mm A").toDate().getTime()
                        : 0;
                    const dateB = dayjs(b.last_call_date, "DD-MM-YYYY hh:mm A").isValid()
                        ? dayjs(b.last_call_date, "DD-MM-YYYY hh:mm A").toDate().getTime()
                        : 0;
                    return dateB - dateA;
                });
                const mappedData = sortedData.map((item: any, index: number, array: any[]) => ({
                    ...item,
                    service_name: `Service ${array.length - index}`,
                }));
                setServiceListFromDB(mappedData);
                const lastFetchedDate = mappedData.length > 0 ? mappedData[0].last_call_date : '';
                setLastFetchedDate(lastFetchedDate);
            }
            else{
                setIsNutriInfoAvailable(false);
            }
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error);
        } finally {
            setIsLoadingList(false);
        }
    }

    const fetchTodaysService = async () => {
        try {
            setIsLoadingPoshanData(true);
            // setCountdown(COUNTDOWN_START);
            // setShowCancelButtons(true);
            // setShowRetryButtons(false);

            abortControllerRef.current = new AbortController();
            const signal = abortControllerRef.current.signal;

            const abhaId = benfDetails?.[0]?.abha_id ?? benfDetails?.[0]?.bal_abha_id ?? null;
            const payload = { abhaId };
            const response = await postDataJSON<any>(`${endpoints.fetchNutriInfoFromPoshan}`, payload, {signal});

            if (response?.data) {
                setIsNutriInfoAvailable(true);
                const todaysService = {
                    service_name: `Service ${serviceListFromDB?.length + 1}`,
                    last_call_date: response?.data?.data?.[0]?.last_call_date ?? null,
                    THR: response?.data?.data?.[0]?.THR ?? null,
                    THR_no_of_day: response?.data?.data?.[0]?.THR_no_of_day ?? null,
                    HCM: response?.data?.data?.[0]?.HCM ?? null,
                    height: response?.data?.data?.[0]?.height ? parseFloat(response?.data?.data?.[0]?.height).toFixed(2) : null,
                    weight: response?.data?.data?.[0]?.weight ? parseFloat(response?.data?.data?.[0]?.weight).toFixed(2) : null,
                    last_thr_given_date: response?.data?.data?.[0]?.last_thr_given_date ?? null,
                    last_hcm_given_date: response?.data?.data?.[0]?.last_hcm_given_date ?? null,
                    last_growth_monitoring_date: response?.data?.data?.[0]?.last_growth_monitoring_date
                        ? dayjs(response?.data?.data?.[0]?.last_growth_monitoring_date).isValid()
                            ? response?.data?.data?.[0]?.last_growth_monitoring_date
                            : null
                        : null,
                };
                if (serviceListFromDB?.length > 0) {
                    updateServiceList(todaysService);
                } else {
                    sendDataToDB(todaysService, true).then(() => {
                        initialFetch(false);
                    });
                }
            }
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error);
            setIsLoadingPoshanData(false);
            if(error.name === "CanceledError") {
                toast.info('Failed to Sync Data, please retry.', { position: 'top-right' });
            }else{
                if (error.response) {
                    const { status, data } = error.response;
                    
                    switch (status) {
                        case 400:
                            toast.error(data?.data?.errorDescription?.health_id?.[0] || 'Bad Request: Invalid request sent to the server.', { position: 'top-right' });
                            break;
                        case 401:
                            if (data?.data?.error === 'ts_missing') {
                                toast.error('Unauthorized: Timestamp is missing.', { position: 'top-right' });
                            } else if (data?.data?.error === 'clientid_missing') {
                                toast.error('Unauthorized: Client ID is missing.', { position: 'top-right' });
                            } else if (data?.data?.error === 'invalid_authentication') {
                                toast.error('Unauthorized: Authentication failed.', { position: 'top-right' });
                            } else if (data?.data?.error === 'token_expired') {
                                toast.error('Unauthorized: Token expired.', { position: 'top-right' });
                            } else {
                                toast.error(data?.data?.message || 'Unauthorized: Authentication failed.', { position: 'top-right' });
                            }
                            break;
                        case 404:
                            toast.error('No Record Found: No nutrition data available.', { position: 'top-right' });
                            break;
                        case 504:
                            toast.error('Gateway Timeout: No response from the server. Please try again later.', { position: 'top-right' });
                            break;
                        default:
                            toast.error(data?.data?.message || 'An error occurred while fetching data.', { position: 'top-right' });
                            break;
                    }
                } else if (error.request) {
                    toast.error('No response from the server. Please check your network connection.', { position: 'top-right' });
                } else {
                    toast.error(`Unexpected Error: ${error.message}`, { position: 'top-right' });
                }
            }
        }
    };

    const updateServiceList = async (todaysService:any) =>{
        try {
            const firstRow = serviceListFromDB[0];
            const payload = {
                partitionKeyDate: firstRow?.partition_key_date,
                beneficiaryServiceId: firstRow?.beneficiary_service_id
            }
            const fetchedDetails = await postDataJSON<any>(`${endpoints.fetchServiceDetailsFromRCH}`, payload);
            
            const firstDate = dayjs(firstRow?.last_call_date, "DD-MM-YYYY hh:mm A");
            const todaysDate = dayjs(todaysService?.last_call_date, "DD-MM-YYYY hh:mm A");
            
            const isSameDate =
            firstDate.isValid() &&
            todaysDate.isValid() &&
            firstDate.format("DD-MM-YYYY") === todaysDate.format("DD-MM-YYYY");
            
            let isDataChanged = false;
            if (isSameDate) {
                isDataChanged = 
                    (fetchedDetails?.data?.[0]?.last_growth_monitoring_date?.split(' ')[0] ?? null) !== (todaysService?.last_growth_monitoring_date ?? null) ||
                    (fetchedDetails?.data?.[0]?.last_thr_given_date?.split(' ')[0] ?? null) !== (todaysService?.last_thr_given_date ?? null) ||
                    (fetchedDetails?.data?.[0]?.last_hcm_given_date?.split(' ')[0] ?? null) !== (todaysService?.last_hcm_given_date ?? null);
                
                    sendDataToDB(todaysService, isDataChanged).then(()=>{
                        initialFetch(false);
                    });
            } else {
                isDataChanged = true;
                sendDataToDB(todaysService, isDataChanged).then(()=>{
                    initialFetch(false);
                });
            }
        } catch (error:any) {
            setIsLoadingPoshanData(false);
            errorLogger(error?.response?.data ?? error?.response ?? error);
        }
    }

    const sendDataToDB = async (newPoshanServices: any, isDataChanged:boolean) => {
        try {
            const payload = {
                abhaId: benfDetails?.[0]?.abha_id ?? benfDetails?.[0]?.bal_abha_id ?? null,
                thr: newPoshanServices?.THR,
                thrNoOfDay: newPoshanServices?.THR_no_of_day,
                hcm: newPoshanServices?.HCM,
                height: parseFloat(newPoshanServices?.height).toFixed(2),
                weight: parseFloat(newPoshanServices?.weight).toFixed(2),
                lastGrowthMonitoringDate: newPoshanServices?.last_growth_monitoring_date,
                lastHcmGivenDate: newPoshanServices?.last_hcm_given_date,
                lastThrGivenDate: newPoshanServices?.last_thr_given_date,
                lastCallDate: newPoshanServices?.last_call_date,
                isDataChanged: isDataChanged,
            }
            const response = await postDataJSON<any>(`${endpoints.insertNutriInfoToRCH}`, payload);
            toast.success('Nutrition data fetched successfully!', { position: 'top-right' });
            setIsLoadingPoshanData(false);
        } catch (error: any) {
            setIsLoadingPoshanData(false);
            toast.error("Error in storing nutrition data in DB", {
                position: "top-right"
            });
        }

    }

    const handleRowClick =async (service: any, index: number) => {
        try {
            setIsCardClicked(true);
            setIsLoadingDetails(true)
            const payload = {
                partitionKeyDate: service?.partition_key_date,
                beneficiaryServiceId: service?.beneficiary_service_id
            }
            const response = await postDataJSON<any>(`${endpoints.fetchServiceDetailsFromRCH}`, payload);
            setPoshanServiceDetails(response?.data?.[0]);
            setPoshanServiceHeader(`${service?.service_name} Details`)
        } catch (error:any) {
            errorLogger(error?.response?.data ?? error?.response ?? error);
        }finally {
            setIsLoadingDetails(false)
        }
        
    };

    const handleBackBtn = () => {
        setIsCardClicked(false);
        setPoshanServiceDetails(null);
        setPoshanServiceHeader('Poshan Service');
        setIsLoadingDetails(false);
    }

    // const retryFetch = () => {        
    //     setCountdown(COUNTDOWN_START);
    //     setShowCancelButtons(true);
    //     setShowRetryButtons(false);
    //     cancelFetch();
    //     fetchTodaysService();
    // };

    // const cancelFetch = () => {
    //     if (abortControllerRef.current) {
    //         abortControllerRef.current.abort(); 
    //         abortControllerRef.current = null;
    //     }
    // };

    return (
        <div className='poshan-services-container'>
            {!isCardClicked &&
                <div className='poshan-service-button-wrapper'>
                    {lastFetchedDate?.length > 0 && <div>{`Last synced on : ${lastFetchedDate}`}</div>}
                    <Button
                        onClick={fetchTodaysService}
                        id="poshan-service-fetch-button"
                        buttonName="Sync Data"
                        colorType="primary"
                        disabled={isLoadingList || isLoadingDetails || isLoadingPoshanData}
                    />
                </div>
            }
            <div className='poshan-services-header-wrapper'>
                {isCardClicked && <div className="poshan-services-backBtn" onClick={handleBackBtn} title='Back'><BackArrowsvg /> Back</div>}
                {!isCardClicked && <div className="poshan-services-header">{poshanServiceHeader}</div>}
            </div>
            {
                isLoadingList? (
                    <ServiceListSkeleton count={3}/>
                 ) :
                (isNutriInfoAvailable && serviceListFromDB.length > 0) ?
                (
                    <div className='poshan-services-content'>
                    {!isCardClicked ? (
                        <div className="poshan-services-list">
                             {isLoadingPoshanData && 
                             <div className="poshan-service-loading-message">
                                <div>
                                    <span>{loadingMessage}</span>
                                    <Spinner/>
                                    {/* <span className='loading-message-countdown'>{countdown}s</span> */}
                                 </div>
                                 {/* {showCancelButtons && <Button
                                    onClick={cancelFetch}
                                    id="poshan-service-cancel-button"
                                    buttonName={"Cancel Sync"}
                                    colorType="secondary"
                                />}
                                {showRetryButtons && <Button
                                    onClick={retryFetch}
                                    id="poshan-service-retry-button"
                                    buttonName={"Retry Sync"}
                                    colorType="secondary"
                                />} */}
                            </div>
                             }
                             {
                                serviceListFromDB.map((service: any, index: number) => (
                                    <PoshanServiceListCard
                                        key={index}
                                        data={service}
                                        handleRowClick={() => handleRowClick(service, index)}
                                    />
                                ))
                            }
                        </div>
                    ) : (
                        <div className="poshan-services-list-details">
                            {isLoadingDetails ? (
                            <ServiceListSkeleton type={'details'}/>
                            ) : (
                                <PoshanServiceDetails data={poshanServiceDetails} />
                            )}
                        </div>
                    )}
                </div>
                )
                :
                (
                    isLoadingPoshanData ? (
                        <div className="poshan-service-loading-message">
                            <div>
                                <span>{loadingMessage}</span>
                                <Spinner />
                            </div>
                        </div>
                        ) :
                        (
                            <div>No Nutritional info available for the beneficiary. </div>
                        )
                )
            }
        </div>
    );
};

export default PoshanComponent;